var $999b0348d4f9e0ae$exports = {};
$999b0348d4f9e0ae$exports = {
    "help": `Ajuda`,
    "info": `Informa\xe7\xf5es`
};


export {$999b0348d4f9e0ae$exports as default};
//# sourceMappingURL=pt-BR.module.js.map
